import { render, staticRenderFns } from "./DropDownMenu.vue?vue&type=template&id=7bc467f2"
import script from "./DropDownMenu.vue?vue&type=script&lang=js"
export * from "./DropDownMenu.vue?vue&type=script&lang=js"
import style0 from "./DropDownMenu.vue?vue&type=style&index=0&id=7bc467f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports